import API from "serviceshift-ui/api-client";

const getStateforType = (type, isTree) => {
  const resource = type.substring(0, type.length - 1);
  const path = isTree ? "CategoryTree" : "Categories";
  return `${resource}${path}`;
};

export default {
  fetchCategories({ commit }, { type, deptId }) {
    return API[type].fetchCategories(deptId).then((res) => {
      commit("replace", {
        state: getStateforType(type, false),
        data: res.data,
      });
    });
  },
  fetchCategoryTree({ commit }, { type, deptId, showAll }) {
    return API[type].fetchCategoryTree(deptId, showAll).then((res) => {
      commit("replace", {
        state: getStateforType(type, true),
        data: res.data,
      });
    });
  },
  fetchCategory(_, { type, deptId, id }) {
    return API[type].fetchCategory(deptId, id);
  },
  createCategory({ dispatch }, { type, deptId, data }) {
    return API[type].createCategory(deptId, data).then(() => {
      dispatch("fetchCategories", { type, deptId });
      dispatch("fetchCategoryTree", { type, deptId });
    });
  },
  updateCategory({ dispatch }, { type, deptId, data }) {
    return API[type].updateCategory(deptId, data).then(() => {
      dispatch("fetchCategories", { type, deptId });
      dispatch("fetchCategoryTree", { type, deptId });
    });
  },
  deleteCategory({ dispatch }, { type, deptId, id }) {
    return API[type].deleteCategory(deptId, id).then(() => {
      dispatch("fetchCategories", { type, deptId });
      dispatch("fetchCategoryTree", { type, deptId });
    });
  },
};
